import { Icon, type IconName } from '@/components/Icon'

export interface ViewTab {
  id: string
  label: string
  icon: IconName
}

/**
 * One place, several views of it.
 *
 * The tabs sit under the breadcrumb rather than in the sidebar because the thing
 * being switched is the *rendering*, not the destination — the same query drawn
 * as rows, as columns, or against dates (ADR-0003). Putting them in the nav
 * would suggest they are different places.
 */
export function ViewTabs({
  tabs,
  active,
  onSelect,
}: {
  tabs: ViewTab[]
  active: string
  onSelect: (id: string) => void
}) {
  return (
    <div className="border-line flex items-center gap-0.5 border-b">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onSelect(tab.id)}
          aria-pressed={active === tab.id}
          className={`-mb-px flex items-center gap-1.5 border-b-2 px-3 py-2 text-[13px] transition-colors ${
            active === tab.id
              ? 'border-brand-600 text-brand-700 font-medium'
              : 'text-ink-500 hover:text-ink-900 border-transparent'
          }`}
        >
          <Icon name={tab.icon} className="size-3.5" />
          {tab.label}
        </button>
      ))}
    </div>
  )
}
